import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import OverAllCreatePopup from "./OverAllCreatePopup";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  setOverReportActions,
  setOverReportCreateActions,
  setOverReportRetrieveActions,
  setTheOverallReportDatas,
  setTheOverallReportTableDatas,
  settheAPI_Key_type,
  setTheAPI_type_IDS,
} from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import ViewSymblos from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";
import RupeesImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-19 (1).svg";
import PersonaImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-18 (1).svg";

const OverAllreport = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const Swal = require("sweetalert2");

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setData] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [search, setsearch] = useState("");
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [show, setShow] = useState(false);
  const initialState = {
    api_type: "",
    recharged_amount: "",
    recharged_date: "",
    GST_amount: "",
  };
  const [data, setDatas] = useState(initialState);
  const [apitypeerr, setapitypeerr] = useState("");
  const [rechargeErr, setrechargeerr] = useState("");
  const [rechargeDateErr, setRechargeErr] = useState("");
  const [typeOfval, setTypeOfVal] = useState();
  const API_TYPES = [
    { value: "", label: "ALL" },
    { value: "0", label: "ZOHO" },
    { value: "1", label: "ARYA" },
    { value: "2", label: "INVINCIBLE" },
    { value: "3", label: "SANDBOX" },
    { value: "4", label: "GUPSHUP" },
  ];
  const ActiveOptions = [
    { value: "0", label: "ALL" },
    { value: "1", label: "CURRENT" },
    { value: "2", label: "PAST RECHARGE" },
  ];
  const [ActiveVal, setActiveVal] = useState({ value: "0", label: "ALL" });
  const [active, setactive] = useState("");

  const HandleActiveAPI = (e) => {
    setActiveVal(e);
    console.log(e, "4390850394skdjf", active);
    if (e != null) {
      // if (e.value == 0) {
      //   setactive(true);
      // } else if (e.value == 1) {
      //   setactive(false);
      // } else if (e.value == "") {
      //   setactive("");
      // }

      if (e.value == 0) {
        setactive("");
      } else if (e.value == 1) {
        setactive(true);
      } else if (e.value == 2) {
        setactive(false);
      }
    }
  };
  console.log(
    active,
    "1928309active",
    state.OverAllReportCall.overAllReport,
    state.OverAllReportCall.Expected_values
  );

  const [OverAllCount, setoverallcount] = useState({
    arya_total_recharges: 0,
    gupshup_total_recharges: 0,
    invincible_total_recharges: 0,
    sandbox_total_recharges: 0,
    zoho_total_recharges: 0,
    approximate_kyc_user: 0,
  });

  const [ApproximateVAL, setApproximatedval] = useState({
    arya_total_recharges: 0,
    gupshup_total_recharges: 0,
    invincible_total_recharges: 0,
    sandbox_total_recharges: 0,
    zoho_total_recharges: 0,
  });

  useEffect(() => {
    if (
      state.OverAllReportCall.overAllReport &&
      state.OverAllReportCall.overAllReport.arya_balance != null &&
      state.OverAllReportCall.overAllReport.gupshup_balance != null &&
      state.OverAllReportCall.overAllReport.sandbox_balance != null &&
      state.OverAllReportCall.overAllReport.zoho_balance != null
    ) {
      const OverAllReportDash = {
        arya_total_recharges:
          state.OverAllReportCall.overAllReport.arya_balance,
        gupshup_total_recharges:
          state.OverAllReportCall.overAllReport.gupshup_balance,
        invincible_total_recharges:
          state.OverAllReportCall.overAllReport.invincible_balance,
        sandbox_total_recharges:
          state.OverAllReportCall.overAllReport.sandbox_balance,
        zoho_total_recharges:
          state.OverAllReportCall.overAllReport.zoho_balance,
        approximate_kyc_user: state.OverAllReportCall.KYC_VALUE_APPROXIMATED,
      };
      setoverallcount(OverAllReportDash);
    } else if (
      state.OverAllReportCall.overAllReport == null ||
      (state.OverAllReportCall.overAllReport.arya_balance == null &&
        state.OverAllReportCall.overAllReport.invincible_balance == null &&
        state.OverAllReportCall.overAllReport.sandbox_balance == null &&
        state.OverAllReportCall.overAllReport.gupshup_balance == null &&
        state.OverAllReportCall.overAllReport.zoho_balance == null)
    ) {
      const OverAllReportDash = {
        arya_total_recharges: 0,
        gupshup_total_recharges: 0,
        invincible_total_recharges: 0,
        sandbox_total_recharges: 0,
        zoho_total_recharges: 0,
        approximate_kyc_user: 0,
      };
      setoverallcount(OverAllReportDash);
    }
  }, [state.OverAllReportCall.overAllReport]);

  useEffect(() => {
    if (
      state.OverAllReportCall.Expected_values &&
      state.OverAllReportCall.Expected_values.arya_hits != null &&
      state.OverAllReportCall.Expected_values.gupshup_hits != null &&
      state.OverAllReportCall.Expected_values.invincible_hits != null &&
      state.OverAllReportCall.Expected_values.sandbox_hits != null &&
      state.OverAllReportCall.Expected_values.zoho_hits != null
    ) {
      const OverAllReportDash = {
        arya_total_recharges: state.OverAllReportCall.Expected_values.arya_hits,
        gupshup_total_recharges:
          state.OverAllReportCall.Expected_values.gupshup_hits,
        invincible_total_recharges:
          state.OverAllReportCall.Expected_values.invincible_hits,
        sandbox_total_recharges:
          state.OverAllReportCall.Expected_values.sandbox_hits,
        zoho_total_recharges: state.OverAllReportCall.Expected_values.zoho_hits,
      };
      setApproximatedval(OverAllReportDash);
    } else if (
      state.OverAllReportCall.Expected_values == null ||
      (state.OverAllReportCall.Expected_values.arya_hits == null &&
        state.OverAllReportCall.Expected_values.gupshup_hits == null &&
        state.OverAllReportCall.Expected_values.sandbox_hits == null &&
        state.OverAllReportCall.Expected_values.invincible_hits == null &&
        state.OverAllReportCall.Expected_values.zoho_hits == null)
    ) {
      const OverAllReportDash = {
        arya_total_recharges: 0,
        gupshup_total_recharges: 0,
        invincible_total_recharges: 0,
        sandbox_total_recharges: 0,
        zoho_total_recharges: 0,
      };
      setApproximatedval(OverAllReportDash);
    }
  }, [state.OverAllReportCall.Expected_values]);

  const onChange = (e) => {
    setDatas({
      ...data,
      recharged_amount: e,
    });
  };
  const onChangeGST = (e) => {
    setDatas({
      ...data,
      GST_amount: e,
    });
  };
  const handleTYpeOfApi = (e) => {
    setTypeOfVal(e);
    setDatas({
      ...data,
      api_type: e.value,
    });
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [date, setDate] = useState(null);
  const [ReportValues, setreportvalues] = useState("");
  const [ReportTypeVal, setReportTypeVal] = useState({
    value: "",
    label: "ALL",
  });
  const HandlereportType = (e) => {
    setReportTypeVal(e);
    setreportvalues(e.value);
  };
  //  console.log(ReportTypeVal , "340ReportTypeVal", ReportValues);
  const handleDate = (inputDate, name) => {
    const value = formatDate(inputDate);
    setDatas({
      ...data,
      recharged_date: value,
    });
  };

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      api_type: ReportValues,
      active: active,
    };
    dispatch(setOverReportActions(payload));
  }, [dtpageindex, search, ReportValues, active]);

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  // console.log(state.OverAllReportCall.overAllReport, "093490238overAllReport");

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const column = [
    {
      Header: "TYPE",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.api_type == 0
                ? "ZOHO"
                : row.row.original.api_type == 1
                ? "ARYA"
                : row.row.original.api_type == 2
                ? "INVINCIBLE"
                : row.row.original.api_type == 3
                ? "SANDBOX"
                : row.row.original.api_type == 4 && "GUPSHUP"}
            </span>
          </>
        );
      },
    },

    {
      Header: "CREATE DATE",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);

        const day = dateObject.getDate();
        const month = dateObject.getMonth() + 1; // getMonth() returns month from 0-11
        const year = dateObject.getFullYear();

        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;

        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span            >
              {`${formattedDay}-${formattedMonth}-${year}`}
            </span>
          </>
        );
      },
    },
    {
      Header: "OPEN BALANCE",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.previous_balance != undefined ? (
              <span>{row.row.original.previous_balance}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "RECHARGED AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.recharged_amount != undefined ? (
              <span>{row.row.original.recharged_amount}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "GST AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.GST_amount != "" &&
            row.row.original.GST_amount != null &&
            row.row.original.GST_amount != undefined ? (
              <span>{row.row.original.GST_amount}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "RECHARGED DATE",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.recharged_date != "" &&
            row.row.original.recharged_date != null &&
            row.row.original.recharged_date != undefined ? (
              <span>{row.row.original.recharged_date}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "BALANCE AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.balance_amount != "" &&
            row.row.original.balance_amount != null &&
            row.row.original.balance_amount != undefined ? (
              <span>{row.row.original.balance_amount}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "center",
                // gap: "5px",
              }}
            >
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  //  console.log(row.row.original , "24323435dfgj");
                  dispatch(setTheOverallReportTableDatas(row.row.original));
                  dispatch(setTheAPI_type_IDS(row.row.original.id));
                  dispatch(settheAPI_Key_type(row.row.original.api_type));

                  navigate("/reportlist");
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={ViewSymblos}/>
                  </span>

                  <span className="ActionsList"> View </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );

  function tochange(e) {
    debouncedSearch(e);
  }
  const HandleSubmit = (e) => {
    // console.log(data, "39740237data");
    var a = 0;
    if (data.api_type == "") {
      a = 1;
      setapitypeerr("*Type is required");
    }
    if (data.recharged_amount == "") {
      a = 1;
      setrechargeerr("*Recharged Amount is required");
    }
    if (data.recharged_date == "") {
      a = 1;
      setRechargeErr("*Recharged Date is required");
    }
    if (a == 0) {
      const payload = {
        data: {
          api_type: data.api_type,
          recharged_amount: Number(data.recharged_amount),
          recharged_date: data.recharged_date,
          GST_amount: Number(data.GST_amount),
        },
      };
      dispatch(setOverReportCreateActions(payload));
      setDatas(initialState);
      setTypeOfVal({});
      setDate(null);
    }
  };

  const HandleExport = (e) => {
    const API_TYPES = [
      { value: "", label: "ALL" },
      { value: "0", label: "ZOHO" },
      { value: "1", label: "ARYA" },
      { value: "2", label: "INVINCIBLE" },
      { value: "3", label: "SANDBOX" },
      { value: "4", label: "GUPSHUP" },
    ];
        // <option value="user_cost_details" selected>USER REPORT</option>

    Swal.fire({
      title: "Do you want to Export?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Export it!",
      //   html: `
      // <div style="display: flex; flex-direction: column; ">
      //   <label style="text-align:left">Select Report Type:</label>
      //   <select id="REPORT" class="swal2-select">
      //     <option value="user_cost_details" selected>USER REPORT</option>
      //     <option value="cost_details">COST REPORT</option>
      //   </select>
      //   <br>
      //   <label for="API_type" style="text-align:left">Select API Type:</label>
      //   <select id="API_type" class="swal2-select">
      //     ${API_TYPES.map(type => `<option value="${type.value}">${type.label}</option>`).join('')}
      //   </select>
      // </div>

      //          `,

      html: `
    <div style="display: flex; flex-direction: column;">
      <label style="text-align:left">Select Report Type:</label>
      <select id="REPORT" class="swal2-select" disabled style="text-align: left;">
        <option value="cost_details">COST REPORT</option>
      </select>
      <br>
      <label for="API_type" style="text-align:left">Service Type:</label>
      <select id="API_type" class="swal2-select" style="text-align: left;">
        ${API_TYPES.map(
          (type) => `<option value="${type.value}">${type.label}</option>`
        ).join("")}
      </select>
    </div>
  `,
      didOpen: () => {
        const reportSelect = document.getElementById("REPORT");
        const apiTypeSelect = document.getElementById("API_type");

        // Store the original options
        const originalOptions = API_TYPES.map(
          (type) => `<option value="${type.value}">${type.label}</option>`
        ).join("");
        // const filteredOptions = API_TYPES.filter((type) => type.value !== "")
        //   .map((type) => `<option value="${type.value}">${type.label}</option>`)
        //   .join("");

        const filteredOptions = API_TYPES.map(
          (type) => `<option value="${type.value}">${type.label}</option>`
        ).join("");

        reportSelect.addEventListener("change", () => {
          // const selectedValue = reportSelect.value;
         const selectedValue = "cost_details";

          console.log("Selected Report Type:", selectedValue);

          if (selectedValue === "cost_details") {
            apiTypeSelect.innerHTML = filteredOptions;
          } else {
            apiTypeSelect.innerHTML = originalOptions; // Restore original options
          }
        });



      },
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedReason = document.getElementById("REPORT").value;
        const SelectAPI_TYPE = document.getElementById("API_type").value;
        console.log(SelectAPI_TYPE, "SelectAPI_TYPE", selectedReason);
        if (selectedReason) {
          console.log("Export with reason:", selectedReason);
          const payload = {
            export_type: selectedReason,
            api_type: SelectAPI_TYPE,
          };
          dispatch(setOverReportRetrieveActions(payload));
        } else {
          Swal.fire({
            text: "Please select a Report type for export.",
            icon: "error",
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: "Export has been Cancelled",
          icon: "error",
          confirmButtonColor: "#234492",
        });
      }
    });
  };
  const HandleEmployeeView = (e) => {
    dispatch(setTheOverallReportTableDatas(e));
    dispatch(setTheAPI_type_IDS(e.id));
    dispatch(settheAPI_Key_type(e.api_type));
    console.log(e, "29390128");

    navigate("/reportlist");
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 style={{fontSize:"16px"}}>Report Overview</h3>
          </div>
          <div className="Add-User col-sm-5">
            <button
              className="ButtonCSS"
              onClick={(e) => {
                // setShow(true)
                navigate("/createreport");
              }}
            >
              Create
            </button>
            <button
              className="ButtonCSS"
              style={{ marginLeft: "20px" }}
              onClick={(e) => {
                HandleExport(e);
              }}
            >
              Export
            </button>
          </div>
        </div>

        <div className="row DashRows DashboardOverview">
            <div className="col-12">
              <h5 style={{ fontWeight: "600", fontSize:"14px" }}>Current Balance</h5>
            </div>

            <div className="col-12 mt-2">

            <div
              className="row DashRows DashboardOverview"
            >
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                >
                  <div
                    className="card-Body DashboardCardBody"
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        width:"195px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"

                      >
                        {/* <i
                          class="fa-solid fa-indian-rupee-sign"
                          style={{ color: "#fff" }}
                        ></i> */}
                        <span  className="OverAllReportImage">
                          <img src={RupeesImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {Math.round(OverAllCount.sandbox_total_recharges)}
                          {/* {OverAllCount.sandbox_total_recharges.toFixed(2)} */}
                        </span>

                        <span
                          style={{ fontSize: "15px", width: "94px" }}
                          className="DashboardCardHeader"
                        >
                          SANDBOX
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
               
                >
                  <div
                    className="card-Body DashboardCardBody"

                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        width:"195px",

                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"
                      >
                        <span  className="OverAllReportImage">
                          <img src={RupeesImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {/* {OverAllCount.gupshup_total_recharges != null
                            ? OverAllCount.gupshup_total_recharges.toFixed(2)
                            : 0} */}
                             {Math.round(OverAllCount.gupshup_total_recharges)}
                        </span>

                        <span
                          style={{ fontSize: "15px", width: "94px" }}
                          className="DashboardCardHeader"
                        >
                          GUPSHUP
                        </span>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
              
                >
                  <div
                    className="card-Body DashboardCardBody"

                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        width:"191px",

                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"
                    
                      >
                       <span  className="OverAllReportImage">
                          <img src={RupeesImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {/* {OverAllCount.invincible_total_recharges != null
                            ? OverAllCount.invincible_total_recharges.toFixed(2)
                            : 0} */}
                            {Math.round(OverAllCount.invincible_total_recharges)}
                        </span>

                        <span
                          style={{ fontSize: "15px" }}
                          className="DashboardCardHeader"
                        >
                          INVINCIBLE
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
               
                >
                  <div
                    className="card-Body DashboardCardBody"
                
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        width:"184px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"

                      >
                        <span  className="OverAllReportImage">
                          <img src={RupeesImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                                                                              marginLeft:"84px",
                          position:"absolute"
                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {/* {OverAllCount.arya_total_recharges != null
                            ? OverAllCount.arya_total_recharges.toFixed(2)
                            : 0} */}
                            {Math.round(OverAllCount.arya_total_recharges)}
                        </span>

                        <span
                          style={{ fontSize: "15px" }}
                          className="DashboardCardHeader"
                        >
                          ARYA
                        </span>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-2 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                >
                  <div
                    className="card-Body DashboardCardBody"

                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        width:"176px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"

                      >
                        <span  className="OverAllReportImage">
                          <img src={RupeesImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                                                    marginLeft:"84px",
                          position:"absolute"
                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {/* {OverAllCount.zoho_total_recharges != null
                            ? OverAllCount.zoho_total_recharges.toFixed(2)
                            : 0} */}
                            {Math.round(OverAllCount.zoho_total_recharges)}
                        </span>

                        <span
                          style={{ fontSize: "15px",width: "94px"  }}
                          className="DashboardCardHeader"
                        >
                          ZOHO
                        </span>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>

        </div>


                  
<div
              className="row DashRows DashboardOverview"

            >


            <div className="col-12" style={{ marginTop:"10px"}}>
              <h5 style={{ fontWeight: "600",fontSize:"14px" }}>Approximate Kyc User Count</h5>
            </div>

            <div className="col-12 mt-2">

            <div
              className="row DashRows DashboardOverview"
            >
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                >
                  <div
                    className="card-Body DashboardCardBody"
             
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        width:"195px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"

                      >
                                               <span  className="OverAllReportImage">
                          <img src={PersonaImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {/* {Math.round(OverAllCount.sandbox_total_recharges)} */}
                          {ApproximateVAL.sandbox_total_recharges}
                        </span>

                        <span
                          className="DashboardCardHeader DashboardHeaderStatus"
                        >
                          SANDBOX
                        </span>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  style={{
                    borderRadius: "7px",
                    // height: "80px",
                    border: "none",
                    // width: "111%",
                    // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"

                  >

                      <div
                        className="DashICON iconsEmpVer RupeeBox"

                      >
                         <span  className="OverAllReportImage">
                          <img src={PersonaImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {ApproximateVAL.gupshup_total_recharges != null
                            ? ApproximateVAL.gupshup_total_recharges
                            : 0}
                        </span>

                        <span
                          style={{ fontSize: "15px", width: "94px" }}
                          className="DashboardCardHeader"
                        >
                          GUPSHUP
                        </span>
                      </div>
                    </div>
                  </div>
                {/* </div> */}
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                >
                  <div
                    className="card-Body DashboardCardBody"

                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        width:"191px"

                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"
                        style={{
                          background: "#234492",
                          border: "3px solid white",
                          width: "59px",
                          borderRadius: "7px",
                        }}
                      >
   <span  className="OverAllReportImage">
                          <img src={PersonaImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {ApproximateVAL.invincible_total_recharges != null
                            ? ApproximateVAL.invincible_total_recharges
                            : 0}
                        </span>

                        <span
                          style={{ fontSize: "15px" }}
                          className="DashboardCardHeader"
                        >
                          INVINCIBLE
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div
                className="col-sm-2 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                >
                  <div
                    className="card-Body DashboardCardBody"

                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        width:"184px"
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"
                        style={{
                          background: "#234492",
                          border: "3px solid white",
                          width: "59px",
                          borderRadius: "7px",
                        }}
                      >
   <span  className="OverAllReportImage">
                          <img src={PersonaImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {ApproximateVAL.arya_total_recharges != null
                            ? ApproximateVAL.arya_total_recharges
                            : 0}
                        </span>

                        <span
                          style={{ fontSize: "15px" }}
                          className="DashboardCardHeader"
                        >
                          ARYA
                        </span>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </div>

              <div
                className="col-sm-2 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                >
                  <div
                    className="card-Body DashboardCardBody"
                  
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                         width:"176px"
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer RupeeBox"
                        style={{
                          background: "#234492",
                          border: "3px solid white",
                          width: "59px",
                          borderRadius: "7px",
                        }}
                      >
   <span  className="OverAllReportImage">
                          <img src={PersonaImage}/>
                        </span>
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            fontWeight: "900",
                          }}
                        >
                          {ApproximateVAL.zoho_total_recharges != null
                            ? ApproximateVAL.zoho_total_recharges 
                            : 0}
                        </span>

                        <span
                          style={{ fontSize: "15px" }}
                          className="DashboardCardHeader"
                        >
                          ZOHO
                        </span>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </div>

              </div>
              </div>
              </div>
          {/* -------------------Approximate-----kyc--------values */}
          <div className="row Approximate" style={{ padding: "0px 30px" }}>
            <div
              // className="col-xl-4 col-sm-6 col-12"
              // className="col-sm-2 col-md-2 col-xl-2"
              className="col-6"
              style={{
                display: "flex",
                alignItems: "center",
                // border: "3px solid red",
                flexDirection: "column",
                 marginLeft:"38px"
              }}
            >
              <div
                className="cards Dashboard01"

              >
                <div
                  className="card-Body DashboardCardBody"

                >
                  {/* <div
                    className="Dash"
                    style={{
                      justifyContent: "start",
                      gap: "11px",
                      margin: "6px",
                      alignItems: "center",
                    }}
                  > */}
                    <div className="DashICON iconsEmpVer RupeeBox">
                      <span
                        style={{
                          color: "#000",
                          fontSize: "13px",
                          fontWeight: "600",
                        }}
                      >
                        ALERT
                      </span>
                    </div>

                    <div
                      className="Counts"
                      style={{
                       
                        display: "flex",
                        flexDirection: "column",
                         position:"absolute",
                          marginLeft:"63px"
                      }}
                    >


                      <span
                        style={{ fontSize: "16px", color: "red", width:"600px", display:"block" }}
                        className="DashboardCardHeader"
                      >
                        {`: Approximately
                          ${
                            OverAllCount.approximate_kyc_user != null &&
                            OverAllCount.approximate_kyc_user != undefined
                              ? OverAllCount.approximate_kyc_user
                              : 0
                          }
                          users can complete their KYC with current credits in wallets.`}
                      </span>
                    </div>
                  </div>
                {/* </div> */}
              </div>
            </div>
          </div>


        <div style={{ padding: " 8px 40px", marginTop: "30px" }}>
          <ReactTable
            data={state.OverAllReportCall.OverAllreportDatas}
            columns={column}
            totalItems={state.OverAllReportCall.Total_Count}
            currentPage={currentPage}
            Search={true}
            // onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.OverAllReportCall.Total_Count}
            API_TYPES={API_TYPES}
            APITYPE={true}
            Filter={true}
            nostatusFilter={true}
            HandlereportType={HandlereportType}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            ReportTypeVal={ReportTypeVal}
            ActiveVal={ActiveVal}
            ActiveFilter={true}
            HandleActiveAPI={HandleActiveAPI}
            ActiveOptions={ActiveOptions}
            MakeCreate={true}
            ViewParts={(e) => {
              HandleEmployeeView(e);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default OverAllreport;
